// components/NavItem.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';

interface NavItemProps {
  to: string;
  label: string;
  isShrunk: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ to, label, isShrunk }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `relative font-medium transition-colors duration-300 
         after:absolute after:-bottom-1 after:left-0 after:w-full after:h-0.5 
         ${isShrunk ? "after:bg-black" : "after:bg-white"} 
         after:scale-x-0 hover:after:scale-x-100 after:origin-left 
         after:transition-transform after:duration-300 
         ${isActive 
           ? `after:scale-x-100 ${isShrunk ? "text-black after:bg-black" : "text-white after:bg-white"}` 
           : isShrunk ? "text-gray-700 hover:text-black" : "text-gray-200 hover:text-white"
         }`
      }
    >
      <span className="text-sm md:text-[15px]">{label}</span>
    </NavLink>
  );
};

export default NavItem;